import useStyles from "../styles";
import logo from "../../../assets/images/logo.svg";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Grid
} from "@mui/material";
import styles from "../report.module.css";
import profilemg from "../../../assets/images/profile.png";

const SessionTemplate2 = ({ profile, scores, allTerms, data, attendance, extra, isPDFVersion = false, appLogo }) => {
  const classes = useStyles();

  const containerStyle = isPDFVersion ? {
    width: "794px",
    padding: "20px",
    boxSizing: "border-box"
  } : {};

  return (
    <div className="container-border page-content white_bg" style={containerStyle}>
      <div className={classes.secondreportmain}>
        <div className={`${classes.secondreportheader} report_border_top`}>
          <Grid container spacing={2}>
            <Grid item lg={3} md={3} sm={3} xs={12}>
              <div className={classes.imageWrapper}>
                <img
                  src={appLogo || logo}
                  alt="App Logo"
                  className={classes.secondlogoContent}
                />
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <div className={classes.reportheadertext}>
                <h1>{data?.school_name || profile?.school_name || "--/--"}</h1>
                <p>{data?.school_address || profile?.address || "--/--"}</p>
                <p>{data?.phone_number || profile?.phone_number || "--/--"}, {data?.email || profile?.email || "--/--"}</p>
              </div>
            </Grid>
            <Grid item lg={3} md={3} sm={3} xs={12}>
              <div>
                <img
                  src={data?.display_pic?.file_url || profilemg}
                  alt="Profile"
                  className={classes.profile}
                />
              </div>
            </Grid>
          </Grid>
        </div>

        <div className={`${classes.secondtermdata} report_border_top`}>
          <h1>2024/2025 FIRST TERM STUDENT REPORT</h1>
        </div>

        <div className={classes.stdninfo}>
          <Grid container spacing={2}>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <div className={classes.profiledata}>
                <h6>STUDENT NAME</h6>
                <p>{data?.last_name || "--/--"} {data?.first_name || "--/--"}</p>
              </div>
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <div className={classes.profiledata}>
                <h6>SEX</h6>
                <p>{data?.gender || "--/--"}</p>
              </div>
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <div className={classes.profiledata}>
                <h6>CLASS</h6>
                <p>{data?.class?.name || "--/--"}</p>
              </div>
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <div className={classes.profiledata}>
                <h6>SESSION</h6>
                <p>{data?.session?.session || "--/--"}</p>
              </div>
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <div className={classes.profiledata}>
                <h6>ADMISSION NO.</h6>
                <p>{data?.admission_no || "--/--"}</p>
              </div>
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <div className={classes.profiledata}>
                <h6>CLASS POPULATION</h6>
                <p>{data?.class_population || "--/--"}</p>
              </div>
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <div className={classes.profiledata}>
                <h6>ADMISSION DATE</h6>
                <p>{data?.admission_date?.substring(0, 10) || "--/--"}</p>
              </div>
            </Grid>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <div className={classes.profiledata}>
                <h6>STUDENT TYPE</h6>
                <p>{data?.student_type || "Day Student"}</p>
              </div>
            </Grid>
          </Grid>
        </div>

        <div className={`${classes.secondtermdata} report_border_top`}>
          <h1>SUBJECTS</h1>
        </div>
      </div>
      {/* Subject Results - Using the table structure from SecondReport */}
      <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 2, mt: 4, overflowY: "auto" }}>
        <Table sx={{ minWidth: 900 }} aria-label="student performance table">
          <TableHead sx={{ backgroundColor: "#f9fafb" }}>
            <TableRow>
              <TableCell sx={{
                position: "sticky",
                left: 0,
                backgroundColor: "#f9fafb",
                zIndex: 2,
                fontWeight: "500"
              }}
              >
                <strong>Subject</strong>
              </TableCell>
              {allTerms.map((term) => (
                <TableCell key={term.id} align="center">
                  {term.name}
                  <br /><Typography variant="caption">(100)</Typography>
                </TableCell>
              ))}
              <TableCell align="center">Average<br /><Typography variant="caption">(100)</Typography></TableCell>
              <TableCell align="center">Grade</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {scores?.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell sx={{
                  position: "sticky",
                  left: 0,
                  backgroundColor: "#fff",
                  zIndex: 1
                }}
                >
                  {row.subject}
                </TableCell>
                {allTerms.map((term) => (
                  <TableCell key={term.id} align="center">
                    {row.termScores[term.id] ?? "-"}
                  </TableCell>
                ))}
                <TableCell align="center">{row?.average ?? "-"}</TableCell>
                <TableCell align="center">{row?.grade ?? "-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Attendance */}
      <div className={`${classes.secondtermdata} report_border_top`}>
        <h1>ATTENDANCE</h1>
      </div>
      <TableContainer component={Paper} sx={{ borderRadius: 2, mt: 4, boxShadow: 1 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#f9fafb" }}>
            <TableRow>
              <TableCell align="center"><strong>TERM</strong></TableCell>
              <TableCell align="center"><strong>TOTAL NO. OF DAYS</strong></TableCell>
              <TableCell align="center"><strong>NO. OF DAYS PRESENT</strong></TableCell>
              <TableCell align="center"><strong>NO. OF DAYS ABSENT</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {attendance.map((record) => (
              <TableRow key={record.term_id}>
                <TableCell align="center">{record.term}</TableCell>
                <TableCell align="center">{record.total_days}</TableCell>
                <TableCell align="center">{record.days_present}</TableCell>
                <TableCell align="center">{record.days_absent}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Grid container spacing={3} sx={{ mt: 1 }}>
        {(extra || [])
          .filter(item => item.section_type === "grade" || item.section_type === "score")
          .map((section, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Paper elevation={2} sx={{ borderRadius: 2, p: "8px 14px" }}>
                <Box sx={{ position: "relative" }}>
                  <div className={classes.termdata}>
                    <h1>{section.section_name.toUpperCase()}</h1>
                  </div>
                </Box>

                <Table sx={{ mt: 2 }}>
                  <TableHead sx={{ backgroundColor: "#f9fafb" }}>
                    <TableRow>
                      <TableCell>ACTIVITY</TableCell>
                      <TableCell align="right">
                        {section.section_type === "grade" ? "GRADE" : "SCORE"}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.entries(section.section_value).map(([activity, value]) => (
                      <TableRow key={`${section.section_name}-${activity}`}>
                        <TableCell>
                          {activity.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)
                          ).join(" ")}
                        </TableCell>
                        <TableCell align="right">
                          {value}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </Grid>
          ))}

        {(extra || [])
          .filter(item => item.section_type === "text")
          .map((section, index) => (
            <Grid item lg={6} md={6} sm={6} xs={12} key={index}>
              <Paper elevation={2} sx={{ borderRadius: 2, p: "8px 14px" }}>
                <Box sx={{ position: "relative" }}>
                  <div className={classes.secondtermdata}>
                    <h1>TEACHER'S COMMENT</h1>
                  </div>
                </Box>

                <Box
                  sx={{
                    mt: 2,
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#f9fafb",
                    fontSize: "0.95rem",
                    textAlign: "left",
                    color: "#333"
                  }}
                >
                  {section?.section_value}
                </Box>
              </Paper>
            </Grid>
          ))}
      </Grid>

      <Grid container spacing={3} className={styles.signdiv}>
        <Grid item lg={7} md={7} sm={7} xs={12} className={styles.sign}>
          <div>
            <p>Class Teacher's Signature</p>
            {data?.class_teacher_signature?.file_url && (
              <img src={data.class_teacher_signature.file_url} alt="Teacher signature" />
            )}
          </div>
          <div>
            <p>Admin's Signature</p>
            {profile?.branding?.signature?.file_url && (
              <img
                src={profile.branding.signature.file_url}
                alt="Admin's Signature"
              />
            )}
          </div>
        </Grid>
        <Grid item lg={4} md={4} sm={4} xs={12} className={styles.seal}>
          {profile?.branding?.school_stamp?.file_url && (
            <img src={profile.branding.school_stamp.file_url} alt="School Seal" />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default SessionTemplate2;
